import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";

const AlertComponent = (
  title,
  mess,
  props,
  btnFunc,
  showAsToast = true,
  btnTxt = "OK"
) => {
  const MySwal = withReactContent(Swal);
  let propsFixed = props ?? {};

  const getTargetContainer = () => {
    const fullscreenElement = document.fullscreenElement ||
      document.webkitFullscreenElement ||
      document.mozFullScreenElement ||
      document.msFullscreenElement;

    if (fullscreenElement) {
      return fullscreenElement;
    }

    return document.body;
  };

  let toastProps = {};
  if (showAsToast) {
    toastProps = {
      toast: true,
      position: "top-end",
      showConfirmButton: false,
      timer: 3000,
      timerProgressBar: true,
      icon: "success",
      didOpen: (toast) => {
        toast.addEventListener("mouseenter", Swal.stopTimer);
        toast.addEventListener("mouseleave", Swal.resumeTimer);
      },
    };
  }

  if (props?.t && mess === "SESSION_EXPIRED") {
    propsFixed.icon = "warning";
    title = props.t("SESSION_EXPIRED_TITLE");

    if (toastProps.icon === "success") {
      toastProps.icon = "warning";
      toastProps.title = props.t("SESSION_EXPIRED_TITLE");
    }
  }

  let args = {
    ...toastProps,
    ...propsFixed,
    target: getTargetContainer(),
  };

  args.title = title;
  if (props && props.t)
    args.text = mess;
  else
    args.text = mess;

  if (btnTxt) args.confirmButtonText = btnTxt;

  // Handle input mode
  if (propsFixed.showInput) {
    // Override toast settings for input mode
    args.toast = false;
    args.showConfirmButton = true;
    args.showCancelButton = true;
    args.cancelButtonText = propsFixed.cancelButtonText || "Cancelar";
    args.timer = undefined;
    args.timerProgressBar = false;

    // Configure input
    args.input = propsFixed.inputType || 'text';
    args.inputPlaceholder = propsFixed.inputPlaceholder || '';
    args.inputValue = propsFixed.inputValue || '';

    // Input validation
    args.inputValidator = (value) => {
      if (propsFixed.inputRequired && !value) {
        return propsFixed.inputErrorMessage || 'Este campo é obrigatório';
      }
      if (propsFixed.inputMinLength && value.length < propsFixed.inputMinLength) {
        return `Mínimo de ${propsFixed.inputMinLength} caracteres`;
      }
      if (propsFixed.customValidator) {
        return propsFixed.customValidator(value);
      }
    };

    // Input attributes
    if (propsFixed.inputAttributes) {
      args.inputAttributes = propsFixed.inputAttributes;
    }
  }

  return MySwal.fire(args).then((result) => {
    if (btnFunc) {
      // Pass both result and input value (if exists)
      btnFunc(result, result.value);
    }
    return result;
  });
};

export default AlertComponent;
